
<template>
  <div v-if="config.isSinglePage">
    <div v-if="appConfig.isQueueUpDomain">
      <app-socket />
      <app-header v-if="!isLoadingPage" />
      <top-menu-profile-hamburger v-if="!isLoadingPage && appConfig && checkMobileDevice && appConfig.auth_check" />
      <top-menu-hamburger v-if="!isLoadingPage && appConfig && typeof userHubData !== 'undefined'" :user-hub-data-prop="userHubData" />
      <top-menu-logo-hamburger v-if="!isLoadingPage && checkMobileDevice()" />
      <app-modals v-if="!isLoadingPage" />
      <queueup-survey-modals v-if="!isLoadingPage" />
      <notifications />
      <div id="website_content">
        <slot v-if="!isLoadingPage" name="content" />
      </div>
      <!--<boom-alert v-if="!isLoadingPage" />-->
      <modal-video-clip-embed />
    </div>
    <div v-else>
      <app-socket />
      <app-header v-if="!isLoadingPage" />
      <top-menu-profile-hamburger v-if="!isLoadingPage && appConfig && checkMobileDevice && appConfig.auth_check" />
      <top-menu-hamburger v-if="!isLoadingPage && appConfig && typeof userHubData !== 'undefined'" :user-hub-data-prop="userHubData" />
      <top-menu-logo-hamburger v-if="!isLoadingPage && checkMobileDevice()" />
      <app-modals v-if="!isLoadingPage" />
      <notifications />
      <div id="website_content">
        <slot v-if="!isLoadingPage" name="content" />
      </div>
      <app-footer v-if="!isLoadingPage" />
      <!--<boom-alert v-if="!isLoadingPage" />-->
      <modal-video-clip-embed />
    </div>
  </div>
</template>
<script>

// import { isLogged } from '../utils/auth';
import { UserAPI } from '../api/user';
import NProgress from 'nprogress';
import { NotificationAPI } from '../api/notfication';
import {
  EventBus,
  SHOW_MODAL_BOOM_MESSAGE,
  SHOW_MODAL_BOOM_CONFIRM, SHOW_MODAL_UPDATE_EMAIL_TWITTER, SHOW_MODAL_ONBOARDING_INITIAL,
  LOAD_MORE_NOTIFICATION, SHOW_MODAL_ONBOARDING_GET_STARTED, SHOW_MODAL_LOGIN,
  SHOW_MODAL_CONFIRM_ADMIN_HIGHSCHOOL, SHOW_MODAL_SWITCH_APP,
} from '../event-bus';
/* const BoomAlert = () => import('./boom-alert');*/
const Notifications = () => import('../components/notifications');
import { mapActions, mapGetters } from 'vuex';
import { UserMixin } from '../mixins/user';
import { helper } from '../mixins/helper';
import { gaEvent } from '../mixins/ga-event';
import { route } from '../mixins/route';
import { ModalMixin } from '../mixins/modal';
import jQuery from 'jquery';
import { url_helper } from '../mixins/url_helper';
const ModalVideoClipEmbed = () => import('../components/modals/ModalVideoClipEmbed');
const queryString = require('query-string');

export default {
  components: { Notifications, ModalVideoClipEmbed },
  mixins: [UserAPI, NotificationAPI, UserMixin, helper, gaEvent, route, ModalMixin, url_helper],
  props: {
    config: {
      type: Object,
      default() {
        return {
          isAvglDomain: false,
          isQueueUpDomain: false,
          content_cloud_front: '',
          content_cloud_front_f: '',
          content_assets_version: '',
          baseUrl: '',
          notificationServer: '',
          sessionId: '',
          csrfToken: '',
          isSinglePage: false,
          cookieSurffix: '',
        };
      },
    },
    // TODO: remove this when single page finish
    user: {
      type: Object,
      default() {
        return {
          id: 1,
        };
      },
    },
    userGeneralData: {
      type: Object,
      default() {
        return {};
      },
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    oldInputForm: {
      type: Array,
      default() {
        return [];
      },
    },
    alert: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      isLoadingPage: true,
      isNotConnectedPlatform: false,
      pageNotification: 1,
    };
  },
  computed: {
    ...mapGetters('user', ['isAuth', 'userData', 'userExtraData', 'userHubData']),
    ...mapGetters('app', ['isShowModalLogin']),
  },
  async created() {
    // Passive event listeners
    jQuery.event.special.touchstart = {
      setup: function(_, ns, handle) {
        this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
      },
    };
    jQuery.event.special.touchmove = {
      setup: function(_, ns, handle) {
        this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
      },
    };

    this.deleteUnnecessaryAllCookies();
    if (this.config.text_tweet) {
      this.shareTwitter(this.config.text_tweet);
    }
    if (this.config.newAccountCreated) {
      this.googleManagerCreateAccount(this.config.newAccountCreated);
      this.twitterTrackingCreateAccount();
    }
    if (this.config.accountLogin) {
      this.googleManagerLogin(this.config.accountLogin);
    }
    this.checkAndShowModalOpenInChrome();
    this.$store.dispatch('app/setConfig', this.config);
    this.$store.dispatch('app/setErrors', this.errors);
    this.$store.dispatch('app/setOldInput', this.oldInputForm);
    if (this.config.isSinglePage) {
      await this.init();
    } else {
      // TODO: remove this when single page finish
      this.$store.dispatch('app/setConfig', this.config);
      // this.setUser(this.user);
      this.getNotifications();
      this.getUserInfo();
      this.setTheme();
    }
    EventBus.$on(LOAD_MORE_NOTIFICATION, this.loadMoreNotification);
  },
  mounted() {
    const self = this;
    setTimeout(function() {
      self.handleActionAlert();
    }, 1000);
  },
  beforeDestroy() {
    EventBus.$off(LOAD_MORE_NOTIFICATION);
  },
  methods: {
    ...mapActions({
      setConnectPlatformData: 'user/setConnectPlatformData',
      setUser: 'user/setUser',
      setUserExtraData: 'user/setExtraData',
      setUserHubData: 'user/setHubData',
      setNumberRewards: 'rewards/setNumberRewards',
      setShowModalOpenInChrome: 'app/setShowModalOpenInChrome',
    }),
    handleActionAlert() {
      if (this.alert === 'invalid_invitation_code') {
        this.showModalBoomMsg('Invalid hub invitation link!');
      }
      this.alert = '';
    },
    deleteUnnecessaryAllCookies() {
      this.delete_cookie('check_userzone');
      this.delete_cookie('is_logged');
      this.delete_cookie('user_zone');
      this.delete_cookie('remember_web_59ba36addc2b2f9401580f014c7f58ea4e30989d');
    },
    setTheme() {
      var currentTheme = localStorage.getItem('theme');
      // with 100 thieves event, theme is always dark (GAME-9031)
      if (this.appConfig.currentRoute && (this.appConfig.currentRoute.includes('pubg.thieves') || this.appConfig.currentRoute.includes('jobs') || (this.appConfig.currentRoute.includes('myprofile') && (location.hash.includes('queue_up') || location.hash.includes('queue_sessions'))))) {
        currentTheme = 'dark';
      }
      if (!currentTheme && !this.appConfig.isAvglDomain) {
        currentTheme = 'light';
        localStorage.setItem('theme', currentTheme);
      }
      // theme default is set to be mobile device theme
      if (this.isMobile()) {
        const isDeviceDarkTheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        if ((isDeviceDarkTheme && currentTheme === 'light') || (!isDeviceDarkTheme && (!currentTheme || currentTheme === 'dark'))) {
          currentTheme = isDeviceDarkTheme ? 'dark' : 'light';
          localStorage.setItem('theme', currentTheme);
        }
      }
      if (currentTheme) {
        document.documentElement.setAttribute('data-theme', currentTheme);
      }
      var dataUpdate = {};
      dataUpdate['theme'] = currentTheme;
      this.$store.dispatch('user/updateUser', dataUpdate);
    },
    async init() {
      // start loading page
      this.isLoadingPage = true;

      const profileQueueupQbuddyModule = (await import('../store/modules/profile/queueup/qbuddy/qbuddy.module')).default;
      await this.$store.registerModule('profileQueueupQbuddy', profileQueueupQbuddyModule);

      const profileModule = (await import('../store/modules/profile/profile.module')).default;
      await this.$store.registerModule('profile', profileModule);

      this.$store.dispatch('app/startLoadPage');
      NProgress.start();
      this.$store.dispatch('app/setConfig', this.config);
      this.$store.dispatch('app/setErrors', this.errors);
      this.$store.dispatch('app/setOldInput', this.oldInputForm);

      // wait get user data
      await this.getUserInfo();
      this.setTheme();

      if (this.appConfig.isQueueUpDomain) {
        await this.$store.dispatch(`profileQueueupQbuddy/getAllowedGames`);
        // at the moment, header does not display notification about queueup games, lobby sessions, incoming orders, so next lines are needed to be hide
        // this.$store.dispatch(`profileQueueupQbuddy/getMyLobbySessions`, { isProvider: 0 });
        // this.$store.dispatch(`profileQueueupQbuddy/getProviderGames`);
        // this.$store.dispatch(`profileQueueupQbuddy/getIncomingOrders`);
      }
      this.isLoadingPage = false;
      await this.$store.dispatch('app/setPageLoaded');
      NProgress.done();

      this.checkUserExisted();
      this.checkNotConnectPlatform();
      this.checkEmptyEmailTwitter();
      this.checkIsAccountConnected();
      this.checkUserAdminLoginGooogle();
      this.checkSwitchApp();

      this.getNotifications();

      localStorage.setItem('current_link_url', window.location.href);

      if (this.isAuth) {
        localStorage.setItem('first_login', 'false');
      }
      if (this.appConfig.isAvglDomain) {
        await this.startOnboardingFlow();
        this.checkFirstTimeAccess();
        this.checkInvite();
      }
      this.initMessageEvent();
    },
    async getUserInfo() {
      // TODO: change to isLogged() when use vuejs on all pages
      if (this.appConfig.auth_check) {
        this.setUser(this.userGeneralData.user);
        if (this.userGeneralData && this.userGeneralData.rewards) {
          this.setNumberRewards(this.userGeneralData.rewards.number_rewards);
        }
        /* const res = await this.getUserInfoAPI();
        if (res.status) {
          // this.setUser(res.data.user);
          this.setUserExtraData(res.data.extra_data);
          this.setUserHubData(res.data.hub_data);
          this.setNumberRewards(res.data.rewards.number_rewards);
        }*/
      }
    },
    async getNotifications() {
      if (this.appConfig.allow_notification === false) {
        return;
      }
      const res = await this.getNotificationsAPI(this.pageNotification);
      if (res.status === 0) {
        this.$store.dispatch('notifications/fetchNotifications', res.data);

        if (Object.keys(res.data.notifications).length === 0) {
          this.pageNotification--;
          if (this.pageNotification < 1) {
            this.pageNotification = 1;
          }
        }
      } else {
        this.pageNotification--;
        if (this.pageNotification < 1) {
          this.pageNotification = 1;
        }
      }
    },

    loadMoreNotification() {
      console.log('page notification: ' + this.pageNotification);
      this.pageNotification++;
      this.getNotifications();
    },

    async startOnboardingFlow() {
      if (this.isAuth) {
        if (this.userData.source === 1) {
          var denyShowOnboardingGetStarted = localStorage.getItem('deny_auto_show_get_started_' + this.userData.id);
          var that = this;
          if (!denyShowOnboardingGetStarted) {
            setTimeout(function() {
              EventBus.$emit(SHOW_MODAL_ONBOARDING_GET_STARTED, that.userData.education_level, 0);
            }, 1000);
          }
        }
      }
    },
    async checkUserExisted() {
      const params = queryString.parse(window.location.search);
      if (params.username_exist) {
        const res = await this.checkUserExistedAPI();
        if (res) {
          const userTypeExisted = res.type;
          const userNameExisted = res.name;
          let msg;
          switch (userTypeExisted) {
            case this.USER_TYPES.EMAIL:
              msg = userNameExisted + ' was created with password on system. Please use your username and password to sign in and connect with your platform';
              break;
            case this.USER_TYPES.TWITTER:
              msg = userNameExisted + ' was signed in through Twitter. You cannot sign up through other platform';
              break;
            case this.USER_TYPES.YOUTUBE:
              msg = userNameExisted + ' was signed in through Youtube. You cannot sign up through other platform';
              break;
            case this.USER_TYPES.MIXER:
              msg = userNameExisted + ' was signed in through Mixer. You cannot sign up through other platform';
              break;
            case this.USER_TYPES.TWITCH:
            case this.USER_TYPES.TWITCH_TEMPORARY:
              msg = userNameExisted + ' was signed in through Twitch. You cannot sign up through other platform';
              break;
            default:
              msg = userNameExisted + ' existed on system. We cannot create new account with same name';
              break;
          }
          EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, msg);
        }
      }
    },
    async checkNotConnectPlatform() {
      const params = queryString.parse(window.location.search);
      if (params.not_connect_platform) {
        const res = await this.getConnectPlatformDataAPI();
        if (res) {
          this.isNotConnectedPlatform = true;
          if (Object.keys(res).length) {
            const connectType = res.connect_type;
            this.setConnectPlatformData(JSON.stringify(res));

            if (!this.isAuth) {
              const msg = 'Welcome to AVGL!<br>Please create an AVGL account to link this ' + this.capitalizeString(connectType) + ' account to.';
              EventBus.$emit(SHOW_MODAL_BOOM_CONFIRM, msg, this.showModalSignUp, 'Ok', 'No', 'Notice', this.removeSessionConnectPlatform, 0);
            }
          }
        }
      }
    },
    showModalSignUp() {
      if (this.appConfig.isAvglDomain) {
        EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL);
      } else {
        EventBus.$emit(SHOW_MODAL_LOGIN);
      }
    },
    removeSessionConnectPlatform() {
      this.setConnectPlatformData('');
    },
    checkEmptyEmailTwitter() {
      const params = queryString.parse(window.location.search);
      if (params.emptyEmailTwitter) {
        setTimeout(function() {
          EventBus.$emit(SHOW_MODAL_UPDATE_EMAIL_TWITTER);
        }, 1000);
      }
    },
    checkIsAccountConnected() {
      const params = queryString.parse(window.location.search);
      if (params.isAccountConnected) {
        const typeConnected = this.capitalizeString(params.type_connected);
        EventBus.$emit(SHOW_MODAL_BOOM_MESSAGE, 'You already have an account with that ' + typeConnected + '!', '', 'OK', this.removeParameterIsAccountConnectedOnUrl);
      }
    },
    checkUserAdminLoginGooogle() {
      if (this.appConfig.isAvglDomain && ((parseInt(this.userData.is_student) === 3 || parseInt(this.userData.is_student) === 2) && parseInt(this.userData.education_level) !== 0) && !parseInt(this.userData.admin_school_id)) {
        setTimeout(function() {
          EventBus.$emit(SHOW_MODAL_CONFIRM_ADMIN_HIGHSCHOOL);
        }, 1000);
      }
    },
    checkSwitchApp() {
      if (this.appConfig.openFromApp) {
        setTimeout(function() {
          EventBus.$emit(SHOW_MODAL_SWITCH_APP);
        }, 1000);
      }
    },
    removeParameterIsAccountConnectedOnUrl() {
      const params = queryString.parse(window.location.search);
      const currentUrl = window.location.toString().replace(location.search, '');
      delete params['isAccountConnected'];
      delete params['type_connected'];
      const query = queryString.stringify(params);
      window.history.pushState('', '', currentUrl + (query.length > 0 ? ('?' + query) : ''));
    },
    checkFirstTimeAccess() {
      const firstTimeAccess = localStorage.getItem('first_time_access');
      const firstLogin = localStorage.getItem('first_login');
      const routeHighschool = this.routeHighSchool();
      const routeHighschoolSupport = this.routeHighSchoolSupport();
      const currUrl = window.location.href;

      if (!firstTimeAccess && !firstLogin) {
        // An user comes to AVGL.org for the first time or has not previously logged in
        setTimeout(() => {
          if (!this.isShowModalLogin && !this.isNotConnectedPlatform && !currUrl.includes(routeHighschool) && currUrl !== routeHighschoolSupport && !currUrl.includes('do_reset_password')) {
            localStorage.setItem('first_time_access', 'false');
            EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL);
          }
        }, 15000);
      } else if (!this.isAuth && !firstLogin) {
        // An user has already navigated to AVGL.org, but has not created an account.
        console.log('initShowOnboardingWhenRegisterAndWatchVideo');
        // TODO:
        // initShowOnboardingWhenRegisterAndWatchVideo();
      } else if (!this.isAuth && firstLogin === 'false') {
        // An user has already navigated to AVGL.org and has an account but is not logged in.
        console.log('initShowLoginAvglWhenRegister');
        // TODO:
        // initShowLoginAvglWhenRegister();
      }
    },
    checkInvite() {
      const params = queryString.parse(window.location.search);
      if (parseInt(params.invite) === 1) {
        if (!this.isAuth) {
          EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL);
        }
      }
    },
    initMessageEvent() {
      if (window.addEventListener) {
        window.addEventListener('message', this.onMessage, false);
      } else if (window.attachEvent) {
        window.attachEvent('onmessage', this.onMessage, false);
      }
    },
    onMessage(event) {
      const linkembed = this.appConfig.urlTitanEmbed;
      // Check sender origin to be trusted
      if (event.origin !== 'https://' + linkembed) {
        return;
      }

      const data = event.data;
      if (typeof (window[data.func]) === 'function') {
        window[data.func].call(null, data.message);
      }
    },
    checkAndShowModalOpenInChrome() {
      if (this.isMobile()) {
        if (!this.isChrome()) {
          const params = queryString.parse(window.location.search);
          if (params.openInChrome) {
            this.setShowModalOpenInChrome(true);
          }
        }
      }
    },
  },
};
</script>
